module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAUCAIAAAD6C3GtAAAAK0lEQVRIx2OwKj1CO8QwavpwNF3Nt4F2iGEUjAJSwQpaAob/tASjpg9H0wGY1ZQD4f8UtgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ee.png
// module id = 812
// module chunks = 0